import { Store } from "redux";
import { GlobalState } from "storefront/GlobalState";
import ViolationModal from "storefront/components/ViolationModal";
import createApp from "../../containers/home";

const render = (node: HTMLElement, store: Store<GlobalState>) =>
  createApp(node, ViolationModal, store);

export default render;
